export const UUIDReg =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export const emailReg =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const UrlReg =
  /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/;
export const regexRegnrSe = /^[a-zA-Z]{3}[0-9]{2}[a-zA-Z0-9]{1}$/;
export const regexRegnrNo = /^[A-Z]{2}\d{5}$/;
export const regexZipSe = /^([0-9]{4})\w+/;
export const regexZipNo = /^[0-9]{4}$/;

export const escapeRegExpString = (s: string) => s.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
